import { createSlice } from '@reduxjs/toolkit';

interface PollingState {
  [key: string]: {
    polling: boolean;
    error: string | null;
  };
}

const initialState: PollingState = {};

const pollingSlice = createSlice({
  name: 'polling',
  initialState,
  reducers: {
    startPolling: (state, action) => {
      const key = action.payload;
      state[key] = { polling: true, error: null };
    },
    stopPolling: (state, action) => {
      const key = action.payload;
      if (state[key]) {
        state[key].polling = false;
      }
    },
    setError: (state, action) => {
      const { key, error } = action.payload;
      if (state[key]) {
        state[key].error = error;
      }
    }
  }
});

export const { startPolling, stopPolling, setError } = pollingSlice.actions;

export const PollingReducer = pollingSlice.reducer;
